import fetch from 'auth/FetchInterceptor'

const LoginLogService = {}

LoginLogService.getLogsHistory = function (params) {
	return fetch({
		url: '/login-history',
		method: 'get',
		params,
	})
}

export default LoginLogService
